import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import { PdfChart } from '../../shared/pdfChart';
import { ExportExcelService } from 'app/service/export-excel.service';
import { ExportPPTService } from 'app/service/export-ppt.service';
import { CpmService } from '../../service/cpm.service';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { GlobalIndexMemberComponent } from '../global-index-member/global-index-member.component';
@Component({
  selector: 'app-market-level-global-index-member',
  templateUrl: './market-level-global-index-member.component.html',
  styleUrls: ['./market-level-global-index-member.component.scss']
})
export class MarketLevelGlobalIndexMemberComponent implements OnInit {
  loadGraphFirstTime = true;

  @ViewChild(GlobalIndexMemberComponent)
  globalIndexMemberComponent: GlobalIndexMemberComponent;

  constructor(
    private cpmService: CpmService,
    private excelService: ExportExcelService,
    private pptService: ExportPPTService
  ) { }

  ngOnInit() { }

  initialChart() {
    if (this.loadGraphFirstTime) {
      this.globalIndexMemberComponent.loadData();
    }
    this.loadGraphFirstTime = false;
  }

  exportFunctionsGlobalIndex() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailGlobalIndex(
        this.globalIndexMemberComponent.radioValue,
        this.cpmService
      )
    );
    arrayOfFunctions.set(
      'print',
      this.exportPrintGlobalIndex(this.globalIndexMemberComponent.radioValue)
    );
    arrayOfFunctions.set(
      'pdf',
      this.exportPdfGlobalIndex(this.globalIndexMemberComponent.radioValue)
    );
    arrayOfFunctions.set(
      'ppt',
      this.exportPptGlobalIndex(
        this.pptService,
        this.globalIndexMemberComponent.dataProvider,
        this.globalIndexMemberComponent.radioValue
      )
    );
    arrayOfFunctions.set(
      'excel',
      this.exportExcelGlobalIndex(
        this.globalIndexMemberComponent
      )
    );
    return arrayOfFunctions;
  }

  exportEmailGlobalIndex = function (radioValue, service) {
    return function mailsectorPopup() {
      service.saveGlobalIndexMemberPdfFile(radioValue).then(filename => {
        const subject = 'Global Index Member';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  };

  exportPrintGlobalIndex = function (radioValue) {
    return function historicalPrint() {
      const popupWin = window.open(
        `/#/globalIndexComposition/${radioValue}`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfGlobalIndex = function (radioValue) {
    const service = this.cpmService;
    return function historicalPdf() {
      service.downloadFile(
        `${
        environment.cpmBaseUrl
        }/pdf/globalIndexComposition?indexType=${radioValue}`
      );
    };
  };

  exportPptGlobalIndex(service, dataProvider, radioValue) {
    return function PptExisting() {
      service.pptGlobalIndexMember(dataProvider, radioValue);
    };
  }

  exportExcelGlobalIndex(globalIndexMemberComponent) {
    return function excelMarketPerformances() {
      globalIndexMemberComponent.excel()
    };
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-level-global-index-member/market-level-global-index-member.component.ts